/**
 * Split Button modules
 */
export * from './split-button';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-splitbuttons/src/split-button/index.js
// module id = 1894
// module chunks = 0